import { useState, useEffect, useCallback } from "react";
import api from "../utils/api";
import toast from "react-hot-toast";

export function useDriverDetails(driverId) {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!driverId) return;
    setLoading(true);
    try {
      const { data } = await api.get(`/api/drivers/${driverId}`);
      setDetails(data);
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to load driver");
    } finally {
      setLoading(false);
    }
  }, [driverId]);

  useEffect(() => { load(); }, [load]);

  async function getDocumentUrl(which) {
    const { data } = await api.get(`/api/drivers/${driverId}/documents/${which}`);
    return data.url;
  }

  return { details, loading, reload: load, getDocumentUrl };
}
